import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, TrendingUp, ChevronRight } from 'lucide-react';

var API_URL = process.env.REACT_APP_BACKEND_URL || '';

function SolutionCard({ slug, title, industry, stakeholder }) {
  return (
    <Link
      to={"/solutions/" + slug}
      className="group block p-4 rounded-xl bg-white border border-gray-100 hover:border-blue-200 hover:shadow-md transition-all"
      data-testid={"trending-" + slug}
    >
      <div className="flex items-start gap-3">
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-gray-900 group-hover:text-[#2C39B8] transition-colors leading-snug mb-2">{title}</h4>
          <div className="flex items-center gap-2">
            <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-blue-50 text-blue-600">{industry}</span>
            {stakeholder && (
              <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-blue-50 text-[#2C39B8]">{stakeholder}</span>
            )}
          </div>
        </div>
        <ChevronRight size={14} className="text-gray-300 group-hover:text-[#2C39B8] flex-shrink-0 mt-1 transition-colors" />
      </div>
    </Link>
  );
}

export default function TrendingSolutions() {
  var state = useState([]);
  var trending = state[0];
  var setTrending = state[1];

  useEffect(function() {
    fetch(API_URL + '/api/seo/trending')
      .then(function(r) { return r.json(); })
      .then(function(data) { setTrending(data.trending || []); })
      .catch(function() {});
  }, []);

  if (trending.length === 0) return null;

  // Pre-render cards to avoid nested .map() in JSX (babel plugin workaround)
  var cards = trending.map(function(page) {
    return <SolutionCard key={page.slug} slug={page.slug} title={page.title} industry={page.industry} stakeholder={page.stakeholder} />;
  });

  return (
    <section className="section" style={{ paddingTop: '60px', paddingBottom: '60px' }} data-testid="trending-solutions-section">
      <div className="container">
        <div className="section-header">
          <span className="section-badge" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            <TrendingUp size={14} /> Trending
          </span>
          <h2>Popular Loyalty Solutions</h2>
          <p>Explore the most viewed B2B channel loyalty programs across industries.</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '12px', marginBottom: '32px' }}>
          {cards}
        </div>

        <div style={{ textAlign: 'center' }}>
          <Link to="/solutions" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', fontSize: '14px', fontWeight: 600, color: '#7CC326', textDecoration: 'none' }} data-testid="trending-view-all">
            Browse All 500+ Solutions <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
